import produce from 'immer';
import { DateTime } from 'luxon';

import { SET_DATA, EXPORT_TRANSACTIONS } from './actions';
import { GAMES_SOURCES, LAST_24_HOURS_VALUE } from '../constants';

export const initialEndDate = new Date();

export const initialStartDate = DateTime.local()
    .minus({ days: LAST_24_HOURS_VALUE })
    .toJSDate();

export const defaultState = {
    period: LAST_24_HOURS_VALUE,
    startDate: initialStartDate,
    endDate: initialEndDate,
    max: 5,
    page: 1,
    error: '',
    exportError: '',
    product: undefined,
    gamesSource: GAMES_SOURCES.COMPLETED_GAMES,
    isLoading: false,
    isExportLoading: false,
    totalRecords: 0,
    history: []
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_DATA:
        case SET_DATA + reducerSuffix: {
            Object.assign(draftState, action.payload);

            break;
        }

        case EXPORT_TRANSACTIONS:
        case EXPORT_TRANSACTIONS + reducerSuffix: {
            const { exportError, isExportLoading } = action.payload;

            Object.assign(draftState, {
                exportError,
                isExportLoading
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
